module.exports = __webpack_public_path__ + "img/vd-date-of-love.142c757b.svg";